import {Component, Inject, OnInit, Optional} from '@angular/core';
import {IGeneralAudit} from 'src/app/interfaces/system-logs.interface';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {UITableHeader} from 'src/app/shared/ui-kits/table/table.models';

@Component({
  selector: 'app-system-changes-popup',
  templateUrl: './system-changes-popup.component.html',
  styleUrls: ['./system-changes-popup.component.scss'],
})
export class SystemChangesPopupComponent implements OnInit {
  public oldValues!: {[key: string]: string | number};
  public newValues!: {[key: string]: string | number};
  public valueArr: {[key: string]: string | number}[] = [];
  public headers: UITableHeader[] = [
    {key: 'FirstNameUA', index: 0},
    {key: 'LastName', index: 0},
    {key: 'LastNameUA', index: 0},
  ];
  constructor(
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IGeneralAudit
  ) {}

  ngOnInit(): void {
    this.oldValues = this.valueParser(this.data.oldValues);
    this.newValues = this.valueParser(this.data.newValues);
    this.valueArr = [this.oldValues, this.newValues];
    this.headers = this.setHeaders(this.valueArr);
  }

  valueParser(value: string) {
    return JSON.parse(value.toString());
  }

  setHeaders(data: {[key: string]: string | number}[]): UITableHeader[] {
    return Object.keys(data[0]).map((header, index) => {
      return {
        key: header,
        index,
      };
    });
  }

  closeModal() {
    this.dialogRef.close();
  }
}
